// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center-media-container,.video-container{display:flex;justify-content:center;align-items:center}.video-container{width:100%}.video-container video{display:block}", ""]);
// Exports
module.exports = exports;
